import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import {Navigate} from 'react-router-dom'

const ProtectedRoute = ({component}) => {
    const {isAuthenticated,isLoading} = useAuth0();
    
    if(isLoading) return <div>Loading..</div>
    if(!isAuthenticated){
        return <Navigate to ='/login' replace/>
    }
    return component
};

export default ProtectedRoute